import React from 'react';
import cx from 'classnames';

import DropDownItem from '../DropDownItem';
import { Text, TextInput } from '../../atoms';

import usePresenter from './DropDownList.presenter';
import getProps from './DropDownList.props';
import { DropDownListCombinedProps } from './types';
import styles from './DropDownList.module.scss';

// MANUAL OVERRIDE - converted to forwardRef Component
const DropDownList = React.forwardRef<HTMLDivElement, DropDownListCombinedProps>((props, ref) => {
  const {
    className,
    classes,
    dropDownItems,
    type, // MANUAL OVERRIDE
    searchInput, // MANUAL OVERRIDE
    bottomBarText, // MANUAL OVERRIDE
    inputRef, // MANUAL OVERRIDE
    ...otherProps // MANUAL OVERRIDE
  } = usePresenter(props);

  const variantName = type || 'Default'; // MANUAL OVERRIDE
  const internalProps = getProps(variantName);
  const currentStyle = styles[`dropDownList${variantName}`];

  const dropDownItemViews = dropDownItems?.map((dropDownItem, index) => (
    <DropDownItem
      key={index}
      className={cx(styles.dropDownItem, classes?.dropDownItem)}
      {...internalProps.dropDownItem}
      {...dropDownItem}
    />
  )) || [];

  let componentView;

  switch (variantName) {
    case 'Default':
      componentView = (
        <div
          ref={ref} // MANUAL OVERRIDE
          {...otherProps} // MANUAL OVERRIDE
          className={cx(currentStyle, className)}
        >
          {dropDownItemViews}
        </div>
      );
      break;
    case 'Search': // MANUAL OVERRIDE
      componentView = (
        <div
          ref={ref}
          {...otherProps}
          className={cx(currentStyle, className)}
        >
          <TextInput
            className={cx(styles.searchInput, classes?.searchInput)}
            {...internalProps.searchInput}
            {...searchInput}
            ref={inputRef}
          />
          {dropDownItemViews}
          <div className={styles.bottomBar}>
            <Text
              {...internalProps.bottomBarText}
              {...bottomBarText}
            />
          </div>
        </div>
      );
      break;
    default:
      componentView = <div>�</div>;
      break;
  }

  return componentView;
}); // MANUAL OVERRIDE

export default DropDownList;
